import React from "react";
import PropTypes from "prop-types";

const Skills = props => {
  return (
    <div className="skills">
      <h1>Skills</h1>
      <div className="skills__front">
        <h2>Front-end:</h2>
        <img src="/images/css3.png" />
        <img src="/images/html5.png" />
        <img src="/images/js.png" height="91" />
        <img src="/images/react.png" height="91" />
      </div>
      <div className="skills__back">
        <h2>Back-end:</h2>
        <img src="/images/node.svg" height="91" />
        <img src="/images/mongo.png" height="110" />
      </div>
    </div>
  );
};

export default Skills;



// WEBPACK FOOTER //
// ./src/component/Skills.js